import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { getReports } from "./api"
export default function ReportCount({ userId }) {
  const [read, setRead] = useState({ loading: true })
  useEffect(() => {
    let current = true
    setRead({ loading: true })
    if (userId) getReports({ payload: [{ reportedId: userId, limit: 1 }] })
      .then(response => { if (current) setRead({ count: response.data.length }) })
      .catch(() => { if (current) setRead({ error: true }) })
    return () => { current = false }
  }, [userId])
  if (!userId || read.error) return <span>Unavailable</span>
  if (read.loading) return <span>Loading…</span>
  return read.count ? <Link to={`/reports-management?reportedId=${userId}`}>{read.count} times</Link> : <span>0 times</span>
}
